module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("Typefaces")]), _vm._v(" "), _c('h3', [_vm._v("Basic")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.notoSans,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.roboto,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("windows")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.segoe,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.sanFrancisco,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Linux")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": _vm.ubuntu,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("Scale")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--title30"
  }, [_vm._v("Title 30")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("35px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--title20"
  }, [_vm._v("Title 20")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("28px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--title10"
  }, [_vm._v("Title 10")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("18px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body20"
  }, [_vm._v("Body 20")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("16px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--body10"
  }, [_vm._v("Body 10")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("14px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--caption20"
  }, [_vm._v("Caption 20")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("12px")]), _vm._v(" "), _c('h3', {
    staticClass: "mt-font--caption10"
  }, [_vm._v("Caption 10")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("11px")]), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Typography")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Chrome OS "), _c('br'), _vm._v("Android")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Apple mac OS"), _c('br'), _vm._v("Apple iOS")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eadb5f7","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typography.vue
// module id = RXj7
// module chunks = 0